<div
  id="user-settings-connectors"
  [class.settings-panel]="!embedded"
  [class.embedded]="embedded"
  [class.mobile]="isMobile"
>
  <div class="head" *ngIf="!embedded">
    <span class="material-icons go-back" (click)="goBack.emit()"> arrow_back </span>
    <div class="description">
      <div class="title">{{ PANELS.CONNECTORS.name }}</div>
      <div class="subtitle">{{ PANELS.CONNECTORS.description }}</div>
    </div>
    <span class="material-icons close" (click)="goBack.emit()"> close </span>
  </div>
  <div class="sub-head" *ngIf="isMobile && !embedded">
    {{ PANELS.CONNECTORS.description }}
  </div>

  <div class="panel-body">
    <div class="connectors-scroll">
    <div class="loading" *ngIf="isLoading">{{ 'Loading…' | translate }}</div>

    <!-- Empty state carries the explanation; there is nowhere else to put it. -->
    <div class="empty" *ngIf="!isLoading && !connectors.length && !showAdd">
      <span class="material-icons empty-icon">hub</span>
      <p>
        {{
          'Your AI teammate can work in other tools — Notion, Jira, your docs — once you connect them here.'
            | translate
        }}
      </p>
    </div>

    <ul class="connector-list" *ngIf="!isLoading && connectors.length">
      <li class="connector" *ngFor="let c of connectors">
        <div class="connector-main">
          <span class="connector-icon">
            <img
              *ngIf="iconFor(c.key, c.mcpUrl); else connectorInitial"
              [src]="iconFor(c.key, c.mcpUrl)"
              [alt]="c.label"
              loading="lazy"
            />
            <ng-template #connectorInitial>
              <span
                class="icon-initial"
                [style.background]="'hsl(' + hueFor(c.key) + ', 62%, 92%)'"
                [style.color]="'hsl(' + hueFor(c.key) + ', 52%, 32%)'"
                >{{ initialFor(c.label) }}</span
              >
            </ng-template>
          </span>
          <div class="connector-label">{{ c.label }}</div>
          <div class="connector-status" [class]="'status-' + c.status">
            {{ statusLabel(c) }}
          </div>
        </div>

        <!-- Which ACCOUNT is connected is the thing most worth showing: the consent
             screen authorizes whoever was signed in to that provider, so this is how
             an admin notices they connected their own account instead of the team's. -->
        <div class="connector-meta" *ngIf="c.status === 'connected'">
          <span *ngIf="c.connectedAccount" class="account">{{ c.connectedAccount }}</span>
          <span *ngIf="c.connectedByName"
            >{{ 'connected by' | translate }} {{ c.connectedByName }}</span
          >
          <span *ngIf="c.lastUsedAt"
            >{{ 'last used' | translate }} {{ c.lastUsedAt | date: 'mediumDate' }}</span
          >
        </div>
        <div class="connector-error" *ngIf="c.lastError">{{ c.lastError }}</div>

        <div class="connector-actions">
          <button type="button" class="link-btn" (click)="connect(c)">
            {{
              (c.status === 'connected' ? 'Reconnect' : 'Connect') | translate
            }}
          </button>
          <button type="button" class="link-btn danger" (click)="remove(c)">
            {{ 'Remove' | translate }}
          </button>
        </div>
      </li>
    </ul>

    <button type="button" class="add-btn" *ngIf="!showAdd" (click)="openAdd()">
      {{ 'Add a connector' | translate }}
    </button>

    <!-- Add flow. The catalog is the primary path: picking a vetted service
         supplies its name, identifier and URL, so an admin never has to know any
         of them. Pasting a URL stays available for anything uncatalogued —
         including a customer's own internal MCP server — which is what keeps
         coverage from depending on our roadmap. -->
    <div class="add-form" *ngIf="showAdd && !manualMode && !picked">
      <div class="field-label">{{ 'Choose a service' | translate }}</div>
      <label class="field catalog-search">
        <input
          type="search"
          [(ngModel)]="search"
          [placeholder]="'Search services — try a name, or what you want to do' | translate"
          autocomplete="off"
        />
      </label>
      <ul class="catalog" *ngIf="!noSearchResults">
        <li
          *ngFor="let e of filteredCatalog"
          class="catalog-item"
          [class.disabled]="isBlocked(e)"
          [attr.aria-disabled]="isBlocked(e) ? 'true' : null"
          role="button"
          (click)="pick(e)"
        >
          <div class="catalog-main">
            <span class="connector-icon">
              <img
                *ngIf="iconFor(e.key); else catalogInitial"
                [src]="iconFor(e.key)"
                [alt]="e.label"
                loading="lazy"
              />
              <ng-template #catalogInitial>
                <span
                  class="icon-initial"
                  [style.background]="'hsl(' + hueFor(e.key) + ', 62%, 92%)'"
                  [style.color]="'hsl(' + hueFor(e.key) + ', 52%, 32%)'"
                  >{{ initialFor(e.label) }}</span
                >
              </ng-template>
            </span>
            <span class="catalog-label">{{ e.label }}</span>
            <span class="catalog-setup" [class]="'setup-' + e.setupPath">
              {{
                e.alreadyConnected
                  ? (catalogActionLabel(e) | translate)
                  : setupLabel(e)
              }}
            </span>
          </div>
          <div class="catalog-blurb">{{ e.blurb }}</div>
          <!-- Said BEFORE they start, not after the provider bounces them. -->
          <div class="catalog-note" *ngIf="e.setupNote && (!e.alreadyConnected || e.multiInstance)">
            {{ e.setupNote }}
          </div>
        </li>
      </ul>
      <!-- Nothing found is not a dead end: our catalog is not the limit of what
           can be connected, so point at the fallback here rather than leaving an
           admin to conclude the service is unsupported. -->
      <div class="empty-search" *ngIf="noSearchResults">
        <p>
          {{ 'No service here matches' | translate }} “{{ search }}”.
          {{
            'If it publishes an MCP server, you can still connect it by URL.'
              | translate
          }}
        </p>
        <button type="button" class="add-btn" (click)="useManual()">
          {{ 'Add by MCP server URL' | translate }}
        </button>
      </div>
      <div class="add-actions">
        <button type="button" class="link-btn" (click)="cancelAdd()">
          {{ 'Cancel' | translate }}
        </button>
        <button type="button" class="link-btn" (click)="useManual()">
          {{ 'Add another MCP server by URL' | translate }}
        </button>
      </div>
    </div>

    <div class="add-form" *ngIf="showAdd && (manualMode || picked)">
      <div class="picked-head" *ngIf="picked">
        <span class="field-label">{{ picked.label }}</span>
        <button type="button" class="link-btn" (click)="backToCatalog()">
          {{ 'Choose a different service' | translate }}
        </button>
      </div>
      <label class="field" *ngIf="!picked">
        <span class="field-label">{{ 'MCP server URL' | translate }}</span>
        <input
          type="url"
          [(ngModel)]="mcpUrl"
          placeholder="https://mcp.notion.com/mcp"
          [disabled]="isDiscovering"
        />
      </label>
      <div class="field-hint" *ngIf="!picked">
        {{
          'Paste the address of the service’s MCP server. We work out the rest.'
            | translate
        }}
      </div>

      <button
        type="button"
        class="add-btn"
        *ngIf="!skipsProbe"
        (click)="discover()"
        [disabled]="isDiscovering || !mcpUrl"
      >
        {{ (isDiscovering ? 'Checking…' : 'Check this server') | translate }}
      </button>

      <div class="discover-error" *ngIf="discoverError">{{ discoverError }}</div>

      <!-- Direct provider: endpoints and scopes come from the catalog, so the
           admin sees exactly what they are granting without a probe step. -->
      <div class="discovery" *ngIf="skipsProbe">
        <div class="scopes" *ngIf="picked?.scopes?.length">
          {{ 'Access requested:' | translate }} {{ picked?.scopes?.join(', ') }}
        </div>
        <!-- The key field lives HERE, in the block a catalog pick without a probe
             renders. It used to sit in the post-discovery block below, which an
             API-key entry never reaches, so Netlify had nowhere to paste a key. -->
        <label class="field" *ngIf="isApiKey">
          <span class="field-label">{{ 'API key' | translate }}</span>
          <input type="password" [(ngModel)]="apiKey" autocomplete="off" />
        </label>
        <div class="field-hint" *ngIf="picked?.setupNote">
          {{ picked?.setupNote }}
        </div>
        <div class="field-hint" *ngIf="isOpen">
          {{
            'This service needs no sign-in — it will be available to the agent as soon as you add it.'
              | translate
          }}
        </div>
        <!-- Only a sign-in has an account to get wrong; a key or an open server
             involves none, so the warning would be a non-sequitur there. -->
        <div class="account-warning" *ngIf="!isApiKey && !isOpen">
          <span class="material-icons">info</span>
          <span>
            {{
              'You’ll connect whichever account is signed in to that service in this browser. For a shared teammate, sign in as the team’s account first.'
                | translate
            }}
          </span>
        </div>
      </div>

      <div class="discovery" *ngIf="discovery && !discovery.problem">
        <div class="discovery-line">
          <span class="material-icons ok">check_circle</span>
          {{
            (discovery.dcr === 'none'
              ? 'Found. This provider needs an OAuth app you create with them.'
              : 'Found. This provider can be connected directly.'
            ) | translate
          }}
        </div>
        <div class="scopes" *ngIf="discovery.scopes?.length">
          {{ 'Access requested:' | translate }} {{ discovery.scopes?.join(', ') }}
        </div>

        <label class="field" *ngIf="!picked">
          <span class="field-label">{{ 'Name' | translate }}</span>
          <input
            type="text"
            [(ngModel)]="label"
            (ngModelChange)="onLabelChange()"
            placeholder="Notion"
          />
        </label>
        <!-- Derived, not demanded. Asking an admin to invent an identifier is
             asking them to do the system's job; it stays visible so it is never
             a surprise, and editable for the rare collision. Hidden entirely when
             a catalog entry already supplied it. -->
        <label class="field" *ngIf="!picked">
          <span class="field-label">{{ 'Identifier' | translate }}</span>
          <input
            type="text"
            [(ngModel)]="key"
            (ngModelChange)="keyTouched = true"
            placeholder="notion"
          />
        </label>
        <div class="field-hint" *ngIf="!picked">
          {{ 'How the agent refers to this service. Set automatically — change it only if you need to.' | translate }}
        </div>

        <ng-container *ngIf="needsManualClient">
          <label class="field">
            <span class="field-label">{{ 'Client ID' | translate }}</span>
            <input type="text" [(ngModel)]="clientId" />
          </label>
          <label class="field">
            <span class="field-label">{{ 'Client secret' | translate }}</span>
            <input type="password" [(ngModel)]="clientSecret" autocomplete="off" />
          </label>
          <div class="field-hint">
            {{
              'Create an OAuth app with this provider, using the redirect URL shown in your Pencil setup guide, then paste its credentials here.'
                | translate
            }}
          </div>
        </ng-container>

        <!-- The account trap. Stated before they leave for the provider, because
             nothing in the OAuth flow itself will warn them. -->
        <div class="account-warning">
          <span class="material-icons">info</span>
          <span>
            {{
              'You’ll connect whichever account is signed in to that service in this browser. For a shared teammate, sign in as the team’s account first.'
                | translate
            }}
          </span>
        </div>
      </div>

      <div class="add-actions">
        <button type="button" class="link-btn" (click)="cancelAdd()">
          {{ 'Cancel' | translate }}
        </button>
        <button
          type="button"
          class="add-btn primary"
          (click)="create()"
          [disabled]="!canCreate || isCreating"
        >
          {{ (isCreating ? 'Adding…' : 'Add connector') | translate }}
        </button>
      </div>
    </div>
  </div>
  </div>
</div>
